import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import _ from 'lodash';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from 'components/Avatar';
import {
  Invitation, ButtonsWrapper, InvitationText, ButtonInvite,
} from './styles';


class InvitationElement extends Component {
  state = {
    loading: false,
  }

  setIsLoading = () => {
    this.setState({ loading: true });
  }

  setIsNoLoading = () => {
    this.setState({ loading: false });
  }

  onAccept = () => {
    const { invitation, onConfirm } = this.props;

    this.setIsLoading();
    onConfirm(invitation, invitation.think_seed.id, this.setIsNoLoading);
  }

  onReject = () => {
    const { invitation, onReject } = this.props;
    this.setIsLoading();
    onReject(invitation.id, invitation.think_seed ? 'think_seed' : 'chat', this.setIsNoLoading);
  }

  render() {
    const {
      invitation, literals, color,
    } = this.props;
    const {
      loading,
    } = this.state;
    let invitationName = '';
    let invitationImage = '';

    if (invitation.think_seed) {
      invitationName = invitation.think_seed.name;
      invitationImage = invitation.think_seed.image;
    } else {
      invitationName = `${invitation.invited_by.firstname} ${invitation.invited_by.lastname}`;
      invitationImage = invitation.invited_by.avatar;
    }

    return (
      <Invitation data-invitation={invitation.id}>
        <Avatar avatar={invitationImage} firstname={invitationName} size={60} />
        <InvitationText>{invitationName}</InvitationText>
        <ButtonsWrapper>
          {!loading && (
            <React.Fragment>
              <ButtonInvite
                color='#F63256'
                onClick={this.onReject}
              >
                {literals.reject}
              </ButtonInvite>
              <ButtonInvite
                color='#2680EB'
                onClick={this.onAccept}
              >
                {literals.accept}
              </ButtonInvite>
            </React.Fragment>
          )}
          {loading && <CircularProgress size={50} style={{ color }} className='buttonProgress' />}
        </ButtonsWrapper>

      </Invitation>
    );
  }
}

InvitationElement.propTypes = {
  invitation: PropTypes.object.isRequired,
  // user: PropTypes.object.isRequired,
  onReject: PropTypes.func.isRequired,
  literals: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  color: PropTypes.string.isRequired,
};

export default InvitationElement;



// WEBPACK FOOTER //
// ./src/routes/Invitations/components/InvitationElement.jsx